import { Row } from 'antd'
import axios from 'axios'
import _ from 'lodash'
import { withSnackbar } from 'notistack'
import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { graphql, compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import styled from 'styled-components'

import HeroProduct from '../../components/HeroProduct'
import { styles } from './styles'
import { GET_MATERIAL_LIST } from '../../graphql/queries'
import { UPDATE_USER } from '../../graphql/mutations'
import { isMobile } from '../../utils'
import Logo from '../../components/Logo'
import Title from '../../components/Title'
import { useDeepEffect } from '../../utils/hooks'
import { RESPONSE_MESSAGE } from '../../utils/constants'

const ButtonFixDiv = styled.div`
  //width: 100%;
  text-align: center;
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  //z-index: 500;
`

export const Product = ({ enqueueSnackbar, me, history: { replace } }) => {
  const [productIdList, setProductIdList] = useState([])

  useDeepEffect(() => {
    setProductIdList(me.products.map((item) => item.material.id))

    return () => {
      setProductIdList([])
    }
  }, [])

  const onSaveMaterialProduct = async (e) => {
    e.preventDefault()
    const token = localStorage.getItem('user-token')
    try {
      await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/hero/material`,
        _.uniq(productIdList),
        {
          headers: {
            Authorization: !_.isNull(token) ? `${token}` : ''
          }
        }
      )
      await enqueueSnackbar(RESPONSE_MESSAGE.SUCCESS)
      await replace('location')
    } catch (error) {
      enqueueSnackbar(error.message)
    }
  }

  return (
    <React.Fragment>
      <AppBar position="sticky">
        <Toolbar style={styles.toolbar}>
          <IconButton style={{ width: '48px' }} />
          <Logo />
          <IconButton style={{ width: '48px' }} />
        </Toolbar>
      </AppBar>
      <Title name="เลือกวัสดุรีไซเคิลที่จะรับ" />
      <Card elevation={isMobile ? 0 : 1} square>
        <CardContent>
          <HeroProduct
            me={me}
            setProductIdList={setProductIdList}
            productIdList={productIdList}
          />
        </CardContent>
        <ButtonFixDiv>
          <Row justify="center">
            <Button
              fullWidth
              variant="contained"
              color="primary"
              style={{ maxWidth: 350 }}
              onClick={(e) => onSaveMaterialProduct(e)}>
              บันทึก
            </Button>
          </Row>
        </ButtonFixDiv>
      </Card>
    </React.Fragment>
  )
}

Product.propTypes = {
  me: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
}

export default compose(
  withRouter,
  withSnackbar,
  graphql(GET_MATERIAL_LIST),
  graphql(UPDATE_USER, { name: 'UpdateUser' })
)(Product)



// WEBPACK FOOTER //
// ./src/pages/Product/index.js